import { createFeature, createReducer, on } from '@ngrx/store';
import { InvoiceActions } from '../actions/invoice.actions';
import { InvoiceState } from '../invoice-state.model';

const initialState: InvoiceState = {
  surveys: [],
  loading: false,
  error: null,
  companies: [],
  companiesLoading: false,
  companiesError: null,
  downloadingType: null,
  regenerating: false,
  filters: null,
  pagination: { page: 1, limit: 20, hasMore: false },
};

export const invoiceFeature = createFeature({
  name: 'invoice',
  reducer: createReducer<InvoiceState>(
    initialState,
    on(InvoiceActions.searchSurveys, (state, { filters }) => ({
      ...state,
      loading: true,
      error: null,
      filters,
      pagination: { ...state.pagination, page: 1 },
    })),
    on(InvoiceActions.loadNextPage, (state) => ({
      ...state,
      loading: true,
      pagination: { ...state.pagination, page: state.pagination.page + 1 },
    })),
    on(InvoiceActions.searchSurveysSuccess, (state, { surveys }) => ({
      ...state,
      loading: false,
      surveys:
        state.pagination.page === 1 ? surveys : [...state.surveys, ...surveys],
      pagination: {
        ...state.pagination,
        hasMore: surveys.length === state.pagination.limit,
      },
      error: null,
    })),
    on(InvoiceActions.searchSurveysFailure, (state, { error }) => ({
      ...state,
      loading: false,
      pagination: {
        ...state.pagination,
        page: Math.max(1, state.pagination.page - 1),
      },
      error,
    })),
    on(InvoiceActions.loadCompanies, (state) => ({
      ...state,
      companiesLoading: true,
      companiesError: null,
    })),
    on(InvoiceActions.loadCompaniesSuccess, (state, { companies }) => ({
      ...state,
      companiesLoading: false,
      companies,
    })),
    on(InvoiceActions.loadCompaniesFailure, (state, { error }) => ({
      ...state,
      companiesLoading: false,
      companiesError: error,
    })),
    on(InvoiceActions.downloadReport, (state, { downloadType }) => ({
      ...state,
      downloadingType: downloadType,
    })),
    on(
      InvoiceActions.downloadReportSuccess,
      InvoiceActions.downloadReportFailure,
      (state) => ({ ...state, downloadingType: null }),
    ),
    on(InvoiceActions.regenerateInvoice, (state) => ({
      ...state,
      regenerating: true,
    })),
    on(
      InvoiceActions.regenerateInvoiceSuccess,
      InvoiceActions.regenerateInvoiceFailure,
      (state) => ({ ...state, regenerating: false }),
    ),
  ),
});
